
import { Vue } from "vue-class-component";

export default class STTPaidUnpaid extends Vue {}
